/**
* @constructor
* Implements a form with steps
*
* @param {Element} form The form element.
*/
export default function FormWithSteps( form ) {

	const emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

	const passwordRegex = /^(?=.*\d)(?=.*\W)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,32}$/;
	const yearRegex = /^\d{4}$/;
	const postalCodeRegex = /^(?:0[1-9]|00[1-9]|[1-9]{2}|[1-9]0)\d{2,3}$/;
	const telRegex = /^[+]?[\s/0-9]{10,17}$/;

	const blackList = document.querySelector( '.bl' ).innerText.split( ',' );

	const globalLiveAlert = document.querySelector( '.form__status' );

	const goNextSteps = form.querySelectorAll( '.js-go-next-step' );
	const goPrevSteps = form.querySelectorAll( '.js-go-prev-step' );
	const submitButton = form.querySelector( '.js-submit' );

	const emailErrorMessage = document.querySelector( '.message-email' ).innerHTML;
	const emailConfirmErrorMessage = document.querySelector( '.message-emailConfirm' ).innerHTML;
	const mdpConfirmErrorMessage = document.querySelector( '.message-mdpConfirm' ).innerHTML;
	const emailBlackListErrorMessage = document.querySelector( '.message-blackList' ).innerHTML;
	const emailExistErrorMessage = document.querySelector( '.message-emailExist' ).innerHTML;
	const requiredErrorMessage = "Veuillez renseigner ce champ.";
	const yearErrorMessage = document.querySelector( '.message-yearError' ).innerHTML;
	const yearDateErrorMessage = document.querySelector( '.message-yearDateError' ).innerHTML;
	const postalCodeErrorMessage = document.querySelector( '.message-postalCode' ).innerHTML;

	const phoneCodeErrorMessage = document.querySelector( '.message-phone' ).innerHTML;

	this.currentStep = false;

	this.init = () => {

		this.hideHiddenFields();

		// init click event
		goNextSteps.forEach( ( elt ) => {
			elt.addEventListener( "click", this.goNextStep );
		} );


		goPrevSteps.forEach( ( elt ) => {
			elt.addEventListener( "click", this.goPrevStep );
		} );

		submitButton.addEventListener( "click", this.submitForm );

		// Affichage conditionnel

		document.querySelector( '.js-status' ).addEventListener( "change", ( e ) => {
			if ( e.target.value == "ACTIVE" || e.target.value == "INACTIVE" ) {
				this.showConditionnalFields( document.querySelectorAll( '.js-status-result' ) );
			} else {
				this.hideConditionnalFields( document.querySelectorAll( '.js-status-result' ) );
			}
		} );


		document.querySelectorAll( '.js-type' ).forEach( ( elt ) => {
			elt.addEventListener( "change", ( e ) => {
				if ( e.target.checked ) {
					this.showConditionnalFields( document.querySelectorAll( '.js-type-result' ) );
				} else {
					this.hideConditionnalFields( document.querySelectorAll( '.js-type-result' ) );
				}
			} );
		} );

		document.querySelectorAll( '.js-psc' ).forEach( ( elt ) => {
			elt.addEventListener( "change", ( e ) => {
				if ( e.target.value == "99" ) {
					this.showConditionnalFields( document.querySelectorAll( '.js-psc-result' ) );
				} else {
					this.hideConditionnalFields( document.querySelectorAll( '.js-psc-result' ) );
				}
			} );
		} );

		document.querySelectorAll( '.js-level' ).forEach( ( elt ) => {
			elt.addEventListener( "change", ( e ) => {
				if ( e.target.value == "99" ) {
					this.showConditionnalFields( document.querySelectorAll( '.js-level-result' ) );
				} else {
					this.hideConditionnalFields( document.querySelectorAll( '.js-level-result' ) );
				}
			} );
		} );


		document.querySelector( '.js-pro' ).addEventListener( "change", ( e ) => {
			if ( e.target.value == "true" ) {
				this.showConditionnalFields( document.querySelectorAll( '.js-pro-result' ) );
			} else {
				this.hideConditionnalFields( document.querySelectorAll( '.js-pro-result, .js-pro-result-hide' ) );
			}
		} );


		document.querySelector( '.js-pro-spe' ).addEventListener( "change", ( e ) => {
			if ( e.target.checked ) {
				this.showConditionnalFields( document.querySelectorAll( '.js-pro-spe-result' ) );
			} else {
				this.hideConditionnalFields( document.querySelectorAll( '.js-pro-spe-result' ) );
			}
		} );

		const allJsChercheur = document.querySelectorAll( '.js-chercheur' );

		allJsChercheur.forEach( ( elt ) => {
			elt.addEventListener( "change", ( e ) => {
				let checkedSpe = document.querySelectorAll( '.js-chercheur:checked' );

				if ( e.target.checked ) {
					this.showConditionnalFields( document.querySelectorAll( '.js-chercheur-result' ) );
				} else {
					if ( checkedSpe.length < 1 ) {
						this.hideConditionnalFields( document.querySelectorAll( '.js-chercheur-result' ) );
					}
				}
			} );
		} );




		document.querySelector( '.js-pro-institute' ).addEventListener( "change", ( e ) => {
			if ( e.target.checked || e.target.value == "autre" ) {
				this.showConditionnalFields( document.querySelectorAll( '.js-pro-institute-result' ) );
			} else {
				this.hideConditionnalFields( document.querySelectorAll( '.js-pro-institute-result' ) );
			}
		} );


	};

	this.goPrevStep = ( e ) => {

		if ( e.target.classList.contains( 'loading' ) ) return;

		// prevent new submit
		e.target.classList.add( 'loading' );

		const button = e.target;
		const step = form.querySelector( `.${button.dataset.step}` );
		const prevSTep = step.previousElementSibling;

		this.resetStep( step );
		this.switchStep( step, prevSTep, "back" );

	};

	this.goNextStep = ( e ) => {

		if ( e.target.classList.contains( 'loading' ) ) return;

		// prevent new submit
		e.target.classList.add( 'loading' );


		globalLiveAlert.innerHTML = "<p>Traitement en cours</p>";

		const button = e.target;
		const step = form.querySelector( `.${button.dataset.step}` );

		this.currentStep = step;

		if ( this.validateStep( step ) ) {

			globalLiveAlert.innerHTML = "";
			const nextSTep = step.nextElementSibling;

			if ( button.dataset.step === "form-step_1" && document.getElementById( 'account.email' ) ) {
				this.checkEmailExist( document.getElementById( 'account.email' ) ).then( ( response ) => {
					if ( response ) {
						document.getElementById( 'account.email' ).setCustomValidity( emailExistErrorMessage );
						document.querySelector( '.loading' ).classList.remove( "loading" );
						this.unvalidateField( document.getElementById( 'account.email' ) );
						document.getElementById( 'error_account.email' ).focus();
					} else {
						this.switchStep( step, nextSTep, "forward" );
					}
				} );
			} else {
				this.switchStep( step, nextSTep, "forward" );
			}

		} else {

			e.target.classList.remove( 'loading' );

			globalLiveAlert.innerHTML = "";

			//focus sur le premier input faux
			const firstInvalidField = form.querySelector( '[aria-invalid="true"]' );

			if ( firstInvalidField ) {
				firstInvalidField.focus();
			}
		}

	};


	this.submitForm = ( e ) => {

		if ( e.target.classList.contains( 'loading' ) ) return;

		// prevent new submit
		e.target.classList.add( 'loading' );

		document.querySelector( '.form__resultMessage' ).innerHTML = "";

		e.stopImmediatePropagation();
		globalLiveAlert.innerHTML = "<p>Traitement en cours</p>";

		const button = e.target;
		const step = form.querySelector( `.${button.dataset.step}` );

		this.currentStep = step;

		if ( this.validateStep( step ) ) {

			this.sendSubmission().then( ( response ) => {


				e.target.classList.remove( 'loading' );
				globalLiveAlert.innerHTML = "";

				if ( response.success ) {

					// Modification step 4 texte with seintinelle email
					const toModifyText = document.querySelector( '.form-step_4__result' ).innerHTML;

					let newText = toModifyText.replaceAll( "[EMAIL]", document.getElementById( 'account.email' ).value );

					document.querySelector( '.form-step_4__result' ).innerHTML = newText;

					// go to next step
					const nextSTep = step.nextElementSibling;
					this.switchStep( step, nextSTep, "forward" );

				} else {
					const p = document.createElement( 'p' );
					p.classList.add( "alert", "alert--error" );
					p.innerHTML = response.data;
					document.querySelector( '.form__resultMessage' ).appendChild( p );
				}

			} );

		} else {

			e.target.classList.remove( 'loading' );

			globalLiveAlert.innerHTML = "";

			//focus sur le premier input faux
			const firstInvalidField = form.querySelector( '[aria-invalid="true"]' );

			if ( firstInvalidField ) {
				firstInvalidField.focus();
			}
		}

	};

	this.switchStep = ( step, nextSTep, direction ) => {
		if ( nextSTep ) {
			this.closeStep( step, direction ).then(
				this.openStep( nextSTep, direction )
			);
		}
	};

	this.closeStep = async ( step, direction ) => {

		const listStep = document.querySelector( '.step.is-current' );

		listStep.classList.remove( 'is-current' );
		listStep.querySelector( '.visually-hidden' ).remove();

		step.dataset.current = "false";
		step.setAttribute( "hidden", "" );

		if ( direction === "forward" ) {
			listStep.classList.add( 'is-done' );
			step.dataset.complete = "true";

			const span = document.createElement( 'span' );
			span.classList.add( 'visually-hidden' );
			span.innerHTML = "Complété :";
			listStep.querySelector( '.stack' ).prepend( span );
		}

		this.currentStep = false;

		return true;

	};

	this.openStep = ( step, direction ) => {

		const doneSteps = document.querySelectorAll( '.step.is-done' );
		let listStep = doneSteps[doneSteps.length - 1].nextElementSibling;

		if ( direction === "back" ) {
			listStep = document.querySelector( `.step_${step.dataset.step}` );
			listStep.classList.remove( "is-done" );
		}

		const span = document.createElement( 'span' );
		span.classList.add( 'visually-hidden' );
		span.innerHTML = "En cours :";

		listStep.classList.add( 'is-current' );
		listStep.querySelector( '.stack' ).prepend( span );

		step.removeAttribute( "hidden" );
		step.dataset.current = "true";
		step.dataset.complete = "false";

		step.querySelector( '.form-step__title' ).focus();

		this.currentStep = step;

		if ( document.querySelector( '.loading' ) ) {
			document.querySelector( '.loading' ).classList.remove( "loading" );
		}

	};

	this.validateStep = ( step ) => {
		let ifOk = true;
		let nbError = 0;
		const fields = Array.from( step.querySelectorAll( 'input, select' ) );
		this.reset( fields );

		// check fields
		fields.forEach( ( f ) => {
			if ( f.getAttribute( 'type' ) !== 'submit' && f.getAttribute( 'type' ) !== 'hidden' ) {

				if ( f.getAttribute( 'type' ) === 'email' ) {
					if ( !this.validateEmail( f ) ) {
						nbError += 1;
					}
				} else if ( f.getAttribute( "name" ) === "patient.birth_date" ) {
					if ( !this.validateBirthYear( f ) ) {
						nbError += 1;
					}
				} else if ( f.getAttribute( "type" ) === "tel" ) {
					if ( !this.validatePhone( f ) ) {
						nbError += 1;
					}
				} else if ( f.getAttribute( "name" ) === "patient.address.zip_code" ) {
					if ( !this.validatePostalCode( f ) ) {
						nbError += 1;
					}
				} else if ( f.dataset.type === 'password' ) {
					if ( !this.validatePassword( f ) ) {
						nbError += 1;
					}
				} else if ( f.dataset.type === 'password-confirm' ) {

					if ( f.value !== this.currentStep.querySelector( '.js-base-mdp' ).value ) {
						f.setCustomValidity( mdpConfirmErrorMessage );
						this.unvalidateField( f );
						nbError += 1;
					}

				} else {

					if ( f.dataset.type === 'js-no-numbers' ) {
						const cleaned = f.value.replace( /(\d)*/g, '' );
						f.value = cleaned;
					}

					if ( !f.checkValidity() ) {
						this.unvalidateField( f );
						nbError += 1;
					}
				}

			}
		} );

		if ( nbError > 0 ) {
			ifOk = false;
		}

		return ifOk;
	};

	this.resetStep = ( step ) => {

		document.querySelector( '.form__resultMessage' ).innerHTML = "";
		const fields = Array.from( step.querySelectorAll( 'input, select' ) );
		this.reset( fields );
	};

	this.validatePhone = ( field ) => {

		if ( field.validity.valueMissing ) {
			field.setCustomValidity( requiredErrorMessage );
			this.unvalidateField( field );
			return false;
		}

		const tel_corrected = field.value.replace( /([-.()])*/g, '' );
		field.value = tel_corrected;

		if ( field.value.match( /\d/g ).length < 10 || field.value.match( /\d/g ).length > 17 ) {
			field.setCustomValidity( phoneCodeErrorMessage );
			this.unvalidateField( field );
		}

		if ( !telRegex.test( field.value ) ) {
			field.setCustomValidity( phoneCodeErrorMessage );
			this.unvalidateField( field );
			return false;
		}
		return true;
	};

	this.validatePostalCode = ( field ) => {
		if ( field.validity.valueMissing ) {
			field.setCustomValidity( requiredErrorMessage );
			this.unvalidateField( field );
			return false;
		}

		if ( field.validity.tooShort ) {
			this.unvalidateField( field );
			return false;
		}

		if ( field.validity.tooLong ) {
			this.unvalidateField( field );
			return false;
		}

		if ( !postalCodeRegex.test( field.value ) ) {
			field.setCustomValidity( postalCodeErrorMessage );
			this.unvalidateField( field );
			return false;
		}

		return true;

	};

	this.validateBirthYear = ( field ) => {
		const currentYear = new Date().getFullYear();
		const birth_date_min = currentYear - 100;
		const birth_date_max = currentYear - 17;

		// Correct data if needed 
		let currentVal = field.value;
		currentVal = currentVal.trim();
		currentVal = currentVal.replace( /\s/g, '' );

		field.value = currentVal;

		if ( field.validity.valueMissing ) {
			field.setCustomValidity( requiredErrorMessage );
			this.unvalidateField( field );
			return false;
		}

		if ( field.validity.tooShort ) {
			this.unvalidateField( field );
			return false;
		}

		if ( field.validity.tooLong ) {
			this.unvalidateField( field );
			return false;
		}

		if ( !yearRegex.test( field.value ) ) {
			field.setCustomValidity( yearErrorMessage );
			this.unvalidateField( field );
			return false;
		}

		if ( field.value > birth_date_max || field.value < birth_date_min ) {
			field.setCustomValidity( yearDateErrorMessage );
			this.unvalidateField( field );
			return false;
		}

		return true;

	};

	this.validateEmail = ( field ) => {

		if ( field.validity.valueMissing ) {
			field.setCustomValidity( requiredErrorMessage );
			this.unvalidateField( field );
			return false;
		}

		if ( !emailRegex.test( field.value ) ) {
			field.setCustomValidity( emailErrorMessage );
			this.unvalidateField( field );
			return false;
		}

		// Check black List
		if ( document.querySelector( '.bl' ) ) {
			if ( blackList.includes( field.value.split( "@" ).pop() ) ) {
				field.setCustomValidity( emailBlackListErrorMessage );
				this.unvalidateField( field );
				return false;
			}
		}

		if ( field.classList.contains( 'js-confirm-email' ) ) {
			if ( field.value !== this.currentStep.querySelector( '.js-base-email' ).value ) {
				field.setCustomValidity( emailConfirmErrorMessage );
				this.unvalidateField( field );
				return false;
			}
		}

		return true;
	};

	this.validatePassword = ( field ) => {

		if ( field.validity.valueMissing ) {
			field.setCustomValidity( requiredErrorMessage );
			this.unvalidateField( field );
			return false;
		}

		let passOk = true;
		let mess = "<div>Le mot de passe doit contenir au moins : <ul>";

		//validationMessage

		if ( field.validity.tooShort ) {
			mess += "<li>8 caractères</li> ";
			passOk = false;
		}

		if ( field.validity.tooLong ) {
			mess += "<li>moins de 32 caractères</li> ";
			passOk = false;
		}

		if ( !passwordRegex.test( field.value ) ) {

			if ( !field.value.match( /[a-z]/g ) ) {
				mess += "<li>une lettre minuscule</li> ";
			}

			if ( !field.value.match( /[A-Z]/g ) ) {
				mess += "<li>une lettre majuscule</li> ";
			}

			if ( !field.value.match( /[0-9]/g ) ) {
				mess += "<li>un chiffre</li> ";
			}

			if ( !field.value.match( /[?=.*\W]/g ) ) {
				mess += "<li>un caractère spécial</li> ";
			}


			mess += "</ul></div>";

			passOk = false;
		}

		if ( !passOk ) {
			field.setCustomValidity( mess );
			this.unvalidateField( field );
			return false;
		}

		return true;

	};

	this.validateField = ( f ) => {
		let parent = f.parentElement;
		if ( f.getAttribute( 'type' ) === 'password' || f.dataset.type === "password" || f.dataset.type === "password-confirm" || f.tagName == "SELECT" ) {
			parent = f.parentElement.parentElement;
		}

		if ( f.classList.contains( 'toggle__input' ) ) {
			parent = f.parentElement.parentElement.parentElement;
		}

		f.setCustomValidity( '' );
		f.setAttribute( 'aria-invalid', false );
		if ( parent.querySelector( '.indiError' ) ) {
			parent.querySelector( '.indiError' ).remove();
		}
	};

	this.unvalidateField = ( f ) => {
		f.setAttribute( 'aria-invalid', true );
		this.addErrorToField( f );
	};

	this.addErrorToField = ( f, c = '' ) => {
		let parent = f.parentElement;

		if ( f.dataset.type === "password" || f.dataset.type === "password-confirm" || f.tagName == "SELECT" ) {
			parent = f.parentElement.parentElement;
		}

		if ( f.classList.contains( 'toggle__input' ) ) {
			parent = f.parentElement.parentElement.parentElement;
		}

		const errorId = `error_${f.getAttribute( 'name' )}`;
		const errorBlock = document.createElement( 'div' );
		errorBlock.id = errorId;
		errorBlock.setAttribute( 'tabindex', '-1' );
		errorBlock.className = `indiError ${c}`;
		errorBlock.innerHTML = `${this.getErrorMessage( f )}`;

		let oldDescribed = f.getAttribute( 'aria-describedby' );
		f.setAttribute( 'aria-describedby', `${errorId} ${oldDescribed}` );

		parent.querySelector( "label" ).after( errorBlock );
	};

	this.getErrorMessage = ( f ) => {
		let em = f.validationMessage;
		return em;
	};

	this.reset = ( fields ) => {
		fields.forEach( ( f ) => {
			if ( f.getAttribute( 'type' ) !== 'submit' && f.getAttribute( 'type' ) !== 'hidden' ) {
				this.validateField( f );
			}
		} );
	};


	this.checkEmailExist = ( field ) => {
		const action = "checkEmailExist";
		const ajaxurl = form.dataset.ajaxurl;
		const nonce = form.dataset.nonce;

		const data = {
			action: action,
			nonce: nonce,
			mail: field.value
		};

		return fetch( ajaxurl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Cache-Control': 'no-cache',
			},
			body: new URLSearchParams( data ),
		} )
			.then( response => response.json() )
			.then( body => {

				return !!( body.success );
			} );
	};


	this.sendSubmission = () => {
		const action = "submitInscriptionForm";
		const ajaxurl = form.dataset.ajaxurl;
		const nonce = form.dataset.nonce;

		const data = new FormData( form );
		data.append( 'action', action );
		data.append( 'nonce', nonce );

		const cancerTypes = [];
		const speciality = [];
		const institutes = [];

		form.querySelectorAll( 'input[name="patient.condition.body_site"]:checked' ).forEach( ( checkbox ) => {
			cancerTypes.push( checkbox.getAttribute( 'value' ) );
		} );

		form.querySelectorAll( 'input[name="patient.pro_specialty"]:checked' ).forEach( ( checkbox ) => {
			if ( checkbox.getAttribute( 'value' ) != "" && checkbox.getAttribute( 'value' ) != "autre" ) {
				speciality.push( checkbox.getAttribute( 'value' ) );
			}
		} );

		form.querySelectorAll( 'input[name="patient.pro_institute"]:checked' ).forEach( ( checkbox ) => {
			if ( checkbox.getAttribute( 'value' ) != "" && checkbox.getAttribute( 'value' ) != "autre" ) {
				institutes.push( checkbox.getAttribute( 'value' ) );
			}
		} );


		data.set( 'patient.condition.body_site', cancerTypes );
		data.set( 'patient.pro_specialty', speciality );
		data.set( 'patient.pro_institute', institutes );

		return fetch( ajaxurl, {
			method: 'POST',
			body: data,
		} )
			.then( response => response.json() )
			.then( body => {

				return body;
			} )
			.catch( ( error ) => {
				console.error( error );
			} );

	};



	this.showConditionnalFields = ( group ) => {
		group.forEach( ( g ) => {
			const fields = g.querySelectorAll( 'input, select' );
			fields.forEach( ( f ) => {
				f.removeAttribute( "aria-disabled" );
			} );
			g.removeAttribute( "hidden" );
		} );
	};

	this.hideConditionnalFields = ( group ) => {
		group.forEach( ( g ) => {
			g.setAttribute( "hidden", "" );
			const fields = g.querySelectorAll( 'input, select' );
			fields.forEach( ( f ) => {
				f.setAttribute( "aria-disabled", true );

				if ( f.getAttribute( 'type' ) === "text" ) {
					f.setAttribute( "value", "" );
				}

				if ( f.dataset.type === "select" ) {
					f.selectedIndex = 0;
				}

				f.checked = false;

			} );
		} );
	};


	this.hideHiddenFields = () => {
		const hiddenGroups = form.querySelectorAll( ".form-step [hidden]" );
		hiddenGroups.forEach( ( elt ) => {
			const fields = elt.querySelectorAll( 'input, select' );
			fields.forEach( ( f ) => {
				f.setAttribute( "aria-disabled", true );

				if ( f.getAttribute( 'type' ) === "text" ) {
					f.setAttribute( "value", "" );
				}

				f.checked = false;
			} );
		} );
	};



}